'use strict';

import {TALENT_POOL_USER_VALIDATION_ERRORS} from "../../../hmodules/talent-pool/constants/talent-pool.constants.js";
import {getValidateShortListedCandidatesModalController} from "../../../hmodules/talent-pool/modals/validate-short-listed-candidates/validate-short-listed-candidates.modal.js";

var app = angular.module('harriApp');

app.controller(
  'ShortlistController', ['$modal', 'hUser','$scope','$location','SharedBrand','ShortListAPI','$timeout','asyncGlobalHandler', 'httpHelper','$interpolate','$filter','ShortListData','$rootScope', 'inviteToApplyDataService',
    function ($modal, hUser,$scope,$location,SharedBrand,ShortListAPI,$timeout,asyncGlobalHandler,httpHelper,$interpolate,$filter,ShortListData,$rootScope, inviteToApplyDataService) {

      /**
       * Variables
       */
      $scope.shortlistMembers = [];
      $scope.selectedToInvite = [];
      $scope.loadingShortList = true;
      $scope.selectedBrand = '';
      $scope.invite = {};
      $scope.brandId;
      $scope.loaderRangesArr = _.range(0, 25);
      $scope.userValidationErrors = TALENT_POOL_USER_VALIDATION_ERRORS;


      /**
       * Controller entry point after first call
       */
      $scope.init = function(){

        /* Get Short List Members */
        ShortListAPI.getMembers().then(function(resp){

          $scope.shortlistMembers = resp.data.data.results;
          ShortListData.listIds = _.pluck( resp.data.data.results , 'id' );
          ShortListData.membersCount = $scope.shortlistMembers.length;
          ShortListData.shortlistMembers = $scope.shortlistMembers;
          $scope.brandId = getActiveBrandId();
          ShortListData.broadcastData();

          $scope.loadingShortList = false;

          $timeout(function(){
            $scope.$apply();
          })
        });

      };

      /**
       * Show Remove Candidates from shortlist confirmation msg
       */
      $scope.confirmDeleteSelectedUsers = function(){
        if( $scope.selectedToInvite.length == 0 ){
          $('#confirm-selecting-users .modal').modal('show');
          return false;
        }

        $("#confirm-remove .modal").modal('show');
        $("#confirm-remove .modal").unbind('hidden.bs.modal')
          .on('hidden.bs.modal', function () {
          // go to main candidate profile.
          // $state.go('^');
        });
      }

      $rootScope.$on('ShortListData.deleted', function(event, memberId) {
        /* Remove the deleted users from the View and from the Shared Array */
        var index = _.indexOf( $scope.shortlistMembers,  _.findWhere( $scope.shortlistMembers , { id : memberId } ) );
        if( index != -1 ){
          $scope.shortlistMembers.splice( index , 1 );
        }
      });
      /**
       * Delete the selected users from the ShortList
       */
      $scope.deleteSelectedUsers = function( dontDisplayDeleteMessage ){

        dontDisplayDeleteMessage = dontDisplayDeleteMessage || false;


        if( $scope.selectedToInvite.length != 0 ){

          ShortListAPI.removeMembers( $scope.selectedToInvite ).then(function(resp){

            $("#confirm-remove .modal").modal('hide');

            if( resp.data.status_code) {
             removeCandidateFromTalentPool($scope.selectedToInvite);

              $scope.selectedToInvite = [];

              if( !dontDisplayDeleteMessage ){
                $scope.membersDeletedSuccessfully();
              }


            }

          });
        }
      };


      var removeCandidateFromTalentPool = function (candidateIds) {
          var ids = angular.copy(candidateIds);
          _.each(ids, function (candidateId) {
              ShortListData.broadcastDeleted(candidateId);
          });
          ShortListData.listIds = _.difference(ShortListData.listIds, ids);
          ShortListData.membersCount = ShortListData.listIds.length;
          ShortListData.shortlistMembers = ShortListData.shortlistMembers.filter(function (member) {
              return ids.indexOf(member.id) === -1;
          });
          ShortListData.broadcastData();
      };

        const prepareMembers = (selectedMembers, illegalMembers) => {
            const illegalMembersIds = new Set(illegalMembers.map(member => member.id));
            const illegalUsers = selectedMembers.filter(member => illegalMembersIds.has(member.id));
            const legalUsers = selectedMembers.filter(member => !illegalMembersIds.has(member.id));

            return { illegalUsers, legalUsers };
        };

        $scope.tagCandidates = async () => {
            if (!$scope.selectedToInvite.length) {
                hAlert($filter('translate')('Error!'), $filter('translate')('Please select candidates!'));
                return;
            }
            const brandId = getActiveBrandId();
            const selectedMembers = getSelectedMembers();
            let optedOutErrorObject;
            let blockedFromRehireErrorObject;
            let optedOutMembers = [];
            let blockedFromRehireMembers = [];
            let legalMembers = [];

            if (selectedMembers?.length) {
                try {
                    const selectedMembersId = selectedMembers.map((member) => {
                        return {
                            id: member.id,
                        };
                    }) ;

                    const payload = {
                        candidates: selectedMembersId
                    };

                    const [
                        shortListedCandidates,
                        brandProfile
                    ] = await Promise.all([
                        TalentPoolAPI2.validateShortListedCandidates(brandId, payload),
                        ProfileAPI.getBrandProfile(brandId)
                    ]);

                    optedOutErrorObject = shortListedCandidates?.errors?.find((error) => error?.code === $scope.userValidationErrors.OPTED_OUT_FROM_BUSINESS);
                    blockedFromRehireErrorObject = shortListedCandidates?.errors?.find((error) => error?.code === $scope.userValidationErrors.BLOCKED_FROM_REHIRE);

                    if (!shortListedCandidates.is_valid && (optedOutErrorObject || blockedFromRehireErrorObject)) {
                        if (optedOutErrorObject?.users) {
                            optedOutMembers = prepareMembers(selectedMembers, optedOutErrorObject.users)?.illegalUsers;
                        }

                        if (blockedFromRehireErrorObject?.users) {
                            blockedFromRehireMembers = prepareMembers(selectedMembers, blockedFromRehireErrorObject.users)?.illegalUsers;
                        }

                        legalMembers = prepareMembers(selectedMembers, [...optedOutErrorObject?.users || [], ...blockedFromRehireErrorObject?.users || []])?.legalUsers;
                        $scope.openValidateShortListedCandidatesModal(legalMembers, optedOutMembers, blockedFromRehireMembers, brandProfile);
                    } else {
                        $scope.openAssignTagsModal(brandId, selectedMembers);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        };

        $scope.openAssignTagsModal = (brandId, selectedMembers) => {
            const modalData = () => {
                return {
                    candidates: selectedMembers,
                    brandId: brandId
                };
            };

            $modal({
                controller: "AssignTagsModalController",
                controllerAs: '$ctrl',
                templateUrl: '../hmodules/talent-pool/modals/assign-tags-to-candidates/assign-tags-to-candidates.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: modalData
                }
            });
        };

        $scope.openValidateShortListedCandidatesModal = (legalMembers, optedOutMembers, blockedFromRehireMembers, brandProfile) => {
            const brandId = getActiveBrandId();

            const modalData = () => {
                return {
                    legalMembers,
                    optedOutMembers,
                    blockedFromRehireMembers,
                    brandProfile
                };
            };

            const onSave = () => {
                return (members) => {
                    $scope.openAssignTagsModal(brandId, members);

                };
            };

            $modal(getValidateShortListedCandidatesModalController(modalData, onSave));
        };

      $scope.tags = [];

      $scope.resetSelectedCandidates = function(){
       $scope.selectedToInvite = [];
      }

      /**
       * After Delete Success
       */
      var deleteTimeout = 0;
      $scope.membersDeletedSuccessfully = function(){
        $timeout.cancel( deleteTimeout );
        $scope.disblayDeletedMessage = true;
        deleteTimeout = $timeout(function(){
          $scope.disblayDeletedMessage = false;
        },5000);
      }

      /**
       * Select/Deselect all the users
       */
      $scope.toggleSelect = function(){
        if( $scope.shortlistMembers.length == $scope.selectedToInvite.length ){
          $scope.selectedToInvite = [];
        }else{
          $scope.selectedToInvite = _.pluck( $scope.shortlistMembers , 'id' );
        }
      }


      /**
       * Invite To Apply Section
       * ==========================================
       */

      $scope.toggleInviteToApply = function( id ){

        var idx = $scope.selectedToInvite.indexOf( id );
        if (idx == -1 ) {
          $scope.selectedToInvite.push(id);
        }else{
          $scope.selectedToInvite.splice(idx,1);
        }

        $timeout(function(){
          $scope.$apply();
        });
      }

      var getActiveBrandId = function () {
          var brandId;

          if (hUser.isTopLevelContext()) {
              brandId = hUser.getUserContext().brand_id;
          } else {
              var brandList = hUser.getUser().brands_list;
              var found = _.find(brandList, {"id": hUser.getUserContext().brand_id});
              if (found) {
                  brandId = hUser.getUserContext().brand_id;
              } else {
                  brandId = brandList[0].id;
              }
          }

          return brandId
      };

      var getSelectedMembers = function () {
          var selectedMembers = _.filter($scope.shortlistMembers, function (member) {
              return $scope.selectedToInvite.indexOf(member.id) > -1;
          });

          for (var i in selectedMembers) {
              selectedMembers[i].fullName = selectedMembers[i].firstName + " " + selectedMembers[i].lastName;
          }

          return selectedMembers;
      };

      $scope.inviteToApply = function(){
          if( !$scope.selectedToInvite.length) {
              hAlert($filter('translate')('Error!'), $filter('translate')('Please select candidates!'));
              return;
          }

          var brandId = hUser.isTopLevelContext()? getActiveBrandId(): hUser.getUserContext().brand_id;
          var selectedMembers = getSelectedMembers();

          var modalData = function () {
              return {
                  brandId: brandId,
                  candidates: selectedMembers
              };
          };

          $modal({
              controller: "InviteToApplyModal",
              controllerAs: '$ctrl',
              templateUrl: '../hmodules/talent-pool/modals/invite-to-apply/invite-to-apply.modal.html',
              show: true,
              backdrop: 'static',
              resolve: {
                  modalData: modalData
              }
          });
      };

        var onInviteToApplySendHandler = function (jobId, candidateIds, subject, message, data) {
            $scope.selectedToInvite = [];
            removeCandidateFromTalentPool(candidateIds);
        };

        var onInviteToApplySendEvent = inviteToApplyDataService.onInviteToApplySendAfter(onInviteToApplySendHandler);

      $scope.personTimeout;
      $scope.$watch('selectedToInvite',function(val){
          $scope.newPerson = true;
          $timeout.cancel( $scope.personTimeout );
          $scope.personTimeout = $timeout(function(){
            $scope.newPerson = false;
         }, 1000 );
       }, true);


      /**
       * Construct calls
       */
      $scope.init();

        $scope.$on("$destroy", function () {
            inviteToApplyDataService.off(onInviteToApplySendEvent);
        });
    }]);


app.service('ShortListData',['ShortListAPI','$rootScope',function(ShortListAPI,$rootScope){

    var dataAPI = {
        'listIds': [],
        'membersCount': 0,
        'initialized': false,
        'shortlistMembers': [],
      };

    /**
     * Init to get the count of members inside the ShortList
     */
    dataAPI.init = function(){

      ShortListAPI.getMembersCount().then(function(resp){

        if(resp.status == 200 ){
          dataAPI.membersCount = resp.data.data.count;
          dataAPI.membersCountOrig = resp.data.data.count;
          /* Brodcast the Data to all Controllers */
          dataAPI.broadcastData();
          dataAPI.initialized = true;
        }
      });
      ShortListAPI.getMembersIds().then(function(resp){
        if(resp.data.status_code == 200 ){
          dataAPI.listIds = resp.data.data.results;
          dataAPI.broadcastData();
        }
      });

    }

    dataAPI.broadcastData = function( ){
      $rootScope.$broadcast('ShortListData.updated');
    }

    dataAPI.broadcastDeleted = function(memberId) {
      $rootScope.$broadcast('ShortListData.deleted', memberId);
    }

    dataAPI.fireInviteToApply = function(memberId) {
      $rootScope.$broadcast('Shortlist.InviteToApply', memberId);
    }
    return dataAPI;

}]);


app.factory('ShortListAPI',['asyncGlobalHandler', 'httpHelper',function(asyncGlobalHandler,httpHelper){
  return {
    /**
     * Get all the member inside user shortlist
     * Method: POST
     * URL: /api/v1/short_list
     */
    'getMembers' : function(){

      var request = httpHelper.p('short_list',{"type" : "list"});
      asyncGlobalHandler.watchPromise(request);
      return request;

    },

    /**
     * Get all the member ids inside user shortlist
     * @returns {*}
     */
    'getMembersIds' : function(){

      var request = httpHelper.p('short_list',{"type" : "ids"});
      asyncGlobalHandler.watchPromise(request);
      return request;

    },

    /**
     * Add array of member Id(s) to shortList
     * @param usersIdsArr:Array
     * Method: PUT
     * Url: /api/v1/short_list
     */
    'addMembers': async (usersIdsArr, brandId) => {
        try {
            const data = await BrandAPI.checkEmployerProfileTypeStatus(brandId, usersIdsArr);
            for (let user of data) {
                const {profile_type, has_localized_profile_on_business} = user;
                if (
                    (profile_type === BrandAPI.PROFILE_TYPES.MARKETPLACE && has_localized_profile_on_business) ||
                    (profile_type === BrandAPI.PROFILE_TYPES.LOCALIZED && !has_localized_profile_on_business)
                ) {
                    throw new Error(BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY);
                }
            }

            const request = httpHelper.put('short_list', {'user_ids': usersIdsArr});
            asyncGlobalHandler.watchPromise(request);
            return request;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Delete user from a short list
     * @param usersIdsArr:Array
     * type: POST
     * URL: /api/v1/short_list_delete
     */
    'removeMembers' : function(usersIdsArr){
      var request = httpHelper.p('short_list_delete',{'user_ids': usersIdsArr });
      asyncGlobalHandler.watchPromise(request);
      return request;
    },

    /**
     * Get the count of short listed users
     * type: GET
     * URL: /api/v1/short_list_count
     */
    'getMembersCount' : function(){
      var request = httpHelper.g('short_list_count');
      asyncGlobalHandler.watchPromise(request);
      return request;
    }

  }
}]);
